<template>
  <div class="mobileWrapper topBg">
    <b-row>
      <b-col cols="12">
        <div class="mobile-logo">
          <img :src="logoImg">
        </div>
      </b-col>
    </b-row>
    <b-row class="row-gap">
      <b-col cols="12">
        <div class="myInfo">
          <div class="myInfoIcon">
            <img :src="reviewIcon">
          </div>
          <div class="myInfoContent">
            <h2>Pending Review</h2>
            <p>Thank you for completing the Transfer Request. Your information has been received and is now pending our review and approval.</p>
            <p><strong>Our staff will be in touch for the payment of Transfer Fees, and you will be notified via email once the transfer process has been completed.</strong></p>
            <p><strong>Please allow up to 5 working days for the {{ transferTypeText }} to be processed after submission.</strong></p>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="expire-info">
          Should you have any questions, please contact our team at (65) 6397 2272 or email  <a href="#">enquiry@nirvana.com.sg</a>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoImg: require('@/assets/images/file-transfer/Logo-mobile.svg'),
      // eslint-disable-next-line global-require
      reviewIcon: require('@/assets/images/file-transfer/review-icon.svg'),
      transferType: null,
    }
  },
  computed: {
    transferTypeText() {
      return this.transferType === 'ownership'
        ? 'Transfer of Ownership Request'
        : 'Change of Purchaser Request'
    },
  },
  beforeMount() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      const { token } = this.$route.params
      if (!token) return
      this.$http.get('front-end/file-transfer/file-detail', { params: { token } })
        .then(response => {
          if (response.data.success && response.data.transferRequest) {
            this.transferType = response.data.transferRequest.transferType
          }
        })
        .catch(() => {})
    },
  },
}
</script>
